import { useContext } from "react";

import { Box, Flex, useBreakpointValue, VStack } from "../internal/exports";

import { ContributionContext } from "./context";
import { Description } from "./description/description";
import { Footer } from "./footer/footer";
import { Tags } from "./tags/tags";
import { Header } from "./header/header";
import { Image } from "./image/image";
import { Title } from "./title/title";
import { Budgeting } from "./budgeting/budgeting";
import { Tile } from "./tile/tile";
import { Focusable } from "./focusable/focusable";
import { PinDetails } from "./pin-details/pin-details";

export function ContributionCard() {
  const { id, variant, showImage, imageSrc, cursor, hideHeader } =
    useContext(ContributionContext);

  const isMobile = useBreakpointValue({ base: true, lg: false }) || false;
  const commonCardProps = {
    bg: "white",
    gap: 4,
    boxShadow: "lg",
    borderRadius: "md",
    id: `ehq-contributionCard-${id}`,
    scrollMarginTop: { base: 180, lg: 20 },
    cursor: cursor || "default"
  };

  if (variant === "elevated") {
    return (
      <Flex direction="column" {...commonCardProps} gap={2} height="100%">
        <Image />
        <Flex direction="column" flex={1} p={2}>
          {!hideHeader && (
            <Box w="full">
              <Header />
            </Box>
          )}
          <Box mt={2} flex="1">
            <Title />
            <PinDetails />
            <Description />
          </Box>
          <VStack mt={4} align="start">
            <Tags />
            <Footer />
            <Budgeting />
          </VStack>
        </Flex>
      </Flex>
    );
  }

  if (variant === "horizontal" && !isMobile) {
    return (
      <Flex direction="row" {...commonCardProps}>
        <Image />
        <VStack align="start" w="full" p={2} pl={showImage && imageSrc ? 0 : 2}>
          {!hideHeader && (
            <Box w="full">
              <Header />
            </Box>
          )}
          <Box w="full" flex="1">
            <Title />
            <PinDetails />
            <Description />
          </Box>
          <VStack w="full" align="start">
            <Tags />
            <Footer />
            <Budgeting />
          </VStack>
        </VStack>
      </Flex>
    );
  }

  return (
    <Flex direction="column" height="100%" width="100%" {...commonCardProps}>
      {!hideHeader && (
        <Box w="full" px={2} pt={3} pb={0}>
          <Header />
        </Box>
      )}
      <Flex direction="column" flex={1}>
        {/* Carries v2 CardBody's default flex:1 1 0%; without it the footer
            stops pinning to the bottom of an equal-height grid card. */}
        <Box flex="1">
          <Focusable>
            <Image />
            <Tile>
              <Title />
              <PinDetails />
              <Description />
            </Tile>
          </Focusable>
        </Box>
        <VStack mt={4} align="start" p={2} pt={0} w="full">
          <Tags />
          <Footer />
          <Budgeting />
        </VStack>
      </Flex>
    </Flex>
  );
}
